import React from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import Modal from '@rover/components/src/OverflowTextModal/Modal';
import { Box, Heading, Link, Paragraph } from '@rover/kibble/core';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const GuaranteeModal = ({ isOpen = false, onClose }: Props): JSX.Element => {
  const headerText = t`Every Rover stay receives...`;
  const { current: countryConfiguration } = useCountryConfigurationShim();
  const isTwentyFourSeven = countryConfiguration?.emergencyHotlineHours === '24/7';

  return (
    <Modal onClose={onClose} isOpen={isOpen} data-testid="rover-guarantee-modal">
      <Box width="100%">
        <Heading size="400">{headerText}</Heading>

        <Heading size="300">
          <Link href="https://www.rover.com/rover-guarantee/">{t`Rover Guarantee`}</Link>
        </Heading>

        <Trans>
          <Paragraph size="100">
            At Rover, we're dedicated to giving your pet the best possible care. To help keep your
            pet happy and healthy, all stays and services booked on Rover receive{' '}
            <Link size="100" href="https://www.rover.com/rover-guarantee/">
              our Rover guarantee
            </Link>
            . You can enjoy peace of mind knowing that if your dog becomes ill and needs to see a
            veterinarian, that care will be covered.
          </Paragraph>
        </Trans>

        {isTwentyFourSeven ? (
          <>
            <Heading size="300">{t`24/7 Customer Support`}</Heading>

            <Paragraph size="100">
              {t`You can travel worry-free knowing that in the event of an emergency, Rover's customer support team will be available to assist you and your sitter, 24 hours a day, 7 days a week.`}
            </Paragraph>
          </>
        ) : (
          <>
            <Heading size="300">{t`Trust & Safety Support`}</Heading>

            <Paragraph size="100">
              {t`Our support team and safety resources are available.`}
            </Paragraph>
          </>
        )}

        <Heading size="300">{t`Reservation Protection`}</Heading>

        <Paragraph size="100" mb="8x">
          {t`In the unlikely event your sitter can't care for your pet, Rover will make it right. We'll do everything we can to find a replacement, so you can focus on your trip!`}
        </Paragraph>
      </Box>
    </Modal>
  );
};

export default GuaranteeModal;
